import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject } from "@angular/core";
import { JsonPipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatDialogClose, MatDialogModule } from "@angular/material/dialog";
import { DatePipe } from "@angular/common";
import { ButtonComponent } from "../layout/element/button.component";
import { Review } from "../../../../globalTypes/review.types";
import { RatingComponent } from "./rating.component";
import { UploadImageComponent } from "../image/upload-image.component";
import { ImageUploadPublic } from "../../../../globalTypes/image.types";
import { MatTooltipModule } from "@angular/material/tooltip";
import { UploadService } from "../../services/upload.service";
import { LimiterDirective } from "../../directive/limiter";

export interface EditProductReviewData {
  review: Review
}

@Component({
  selector: 'msh-edit-product-review-dialog',
  imports: [FormsModule, MatDialogClose, MatDialogModule, ButtonComponent, RatingComponent, UploadImageComponent, MatTooltipModule, LimiterDirective],
  template: `
<div class=" text-copy min-w-[50vw]">
  <mat-dialog-content>
    <div class="flex flex-col gap-4">
      <div class=" flex justify-between gap-2">
        <div class="text-lg font-semibold">{{review.statusId === 'pending' ? 'Create' : 'Edit'}} Review</div>
        <msh-rating [(rating)]="review.rating" [readonly]="false"></msh-rating>
      </div>
      <input [limiter]="150" [(ngModel)]="review.title" placeholder="Review Title" class="w-full bg-back text-copy rounded p-2" />
      <div class="flex flex-col gap-2">
        <textarea id="comments" [limiter]="1000" placeholder="Comments" [(ngModel)]="review.body" rows="5" class="w-full border rounded p-2"></textarea>
      </div>
      <msh-upload-image 
        class=" relative -top-6"
          [existingImages]="existingImages"
          [maxFiles]="10"
          [locationId]="review.reviewById"
          [type]="'review'"
          [id]="review.id"
          [dropZoneOnTopAlone]="false"
          (onImageLoading)="onImagesLoading($event)"
          (onImageObjectsUpdated)="onImageObjectsUpdated($event)"
      ></msh-upload-image>
    </div>
  </mat-dialog-content>
  <div class="m-4 mt-4 flex justify-end gap-4">
    <button mat-flat-button [mat-dialog-close]="">Cancel</button>
    <msh-button 
      [matTooltipDisabled]="review.rating > 0"
      matTooltip="You must select a rating before saving."
     [disabled]="review.rating === 0" cta="Save" (onClick)="onSave()"></msh-button>
  </div>
</div>
  `,
  styles: ``
})
export class EditProductReviewDialogComponent {

  messageToBuyer: string = '';
  newImages: {image: ImageUploadPublic; sortOrder: number}[] = [];
  isLoading = false;
  existingImages: { image: ImageUploadPublic; sortOrder: number }[] = [];
  removeImageIds: string[] = [];
  review!: Review;

  constructor(
    private uploadService: UploadService,
    public dialogRef: MatDialogRef<EditProductReviewDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: EditProductReviewData
  ){
    this.review = JSON.parse(JSON.stringify(this.data.review));
    this.existingImages = this.review.reviewImages_on_review || [];
  }

  onImagesLoading(fileNames: string[]){
    this.isLoading = fileNames.length > 0;
  }

  onImageObjectsUpdated(imageObjects: {image: ImageUploadPublic; sortOrder: number}[]){
    this.newImages = imageObjects;
    const currentIds = imageObjects.map(img => img.image.id)
    if(this.review) {
      if(this.review.reviewImages_on_review && this.review.reviewImages_on_review.length > 0){
        this.review.reviewImages_on_review.forEach(imageRef => {
          if(!currentIds.includes(imageRef.image.id)) {
            this.removeImageIds.push(imageRef.image.id); // imageObjectIds
          }
        })
      }
      this.review.reviewImages_on_review = imageObjects;
    }
    // 
  }

  async onSave(){
    if(this.removeImageIds.length > 0){
      await this.uploadService.deleteUploadedImages(this.removeImageIds);
    }
    this.review.reviewImages_on_review = [ ...this.newImages];
    this.dialogRef.close(this.review);
  }
}